<template>
	<div class="tsmap-marker" ref="marker">
		<svg xmlns="http://www.w3.org/2000/svg"
			 width="27"
			 height="38"
			 viewBox="0 0 7.1437498 10.054167"
			 version="1.1"
			 id="svg874">
			<g :fill="color"
			   fill-opacity="1"
			   id="layer1">
				<g id="g839"
				   transform="matrix(0.09016816,0,0,0.09016816,-6.3315914,-8.3780996)">
					<g id="g6"
					   transform="matrix(0.26458333,0,0,0.26458333,55.205103,93.179509)">
						<g id="g4">
							<path d="m 206.549,0 v 0 c -82.6,0 -149.3,66.7 -149.3,149.3 0,28.8 9.2,56.3 22,78.899 l 97.3,168.399 c 6.1,11 18.4,16.5 30,16.5 11.601,0 23.3,-5.5 30,-16.5 l 97.3,-168.299 c 12.9,-22.601 22,-49.601 22,-78.901 C 355.849,66.8 289.149,0 206.549,0 Z m 0,193.4 c -30,0 -54.5,-24.5 -54.5,-54.5 0,-30 24.5,-54.5 54.5,-54.5 30,0 54.5,24.5 54.5,54.5 0,30.1 -24.5,54.5 -54.5,54.5 z"
								  id="path2"/>
						</g>
					</g>
					<ellipse style="fill:#ffffff;fill-opacity:1;stroke-width:0.344629"
							 id="path1458"
							 cx="109.76228"
							 cy="133.29251"
							 rx="31.625706"
							 ry="33.176826">
					</ellipse>
				</g>
			</g>
			<text x="50%" y="40%" class="detail-text">{{ detailText }}</text>
		</svg>
	</div>
</template>

<script>

	export default {
		props: {
			color: {
				type: String,
				default: '#35a5a4'
			},
			detailText: {
				type: String,
				default: '0'
			}
		}
	}
</script>

<style>
.detail-text {
	font-size: 0.2em;
	color: #000;
	text-anchor: middle;
	dominant-baseline: middle;
}
</style>
